import { Box } from "@mui/material";
import styled from "styled-components";

export const ScanningObjectPickerContainer = styled(Box)`
  width: ${(props) => (props?.isEditing ? "80%" : "calc(100% - 220px)")};
  @media (max-width: 600px) {
    width: 100%;
  }
`;
